import { Component, Input, OnInit } from '@angular/core';
import { ModalRef } from '@shared/ui';

@Component({
  template: `
    <!-- TODO: Port modal to webapp stack  -->
  `,
})
export class CreateMilestoneModalComponent implements OnInit {
  @Input() projectId: number;
  @Input() bidderId: number;

  constructor(private modalRef: ModalRef<CreateMilestoneModalComponent>) {}

  ngOnInit() {
    // FIXME: port this modal to the webapp stack
    (<any>window).messagingWebappCompatModals.CreateMilestoneModal.open({
      projectId: this.projectId,
      bidderId: this.bidderId,
    });
  }

  close() {
    this.modalRef.close();
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/projects/create-milestone-modal/create-milestone-modal.component.ts